<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <!-- <div class="card-header bg-transparent pb-5">
          <div class="text-muted text-center mt-2 mb-3">
            <small>{{ $t('login.welcomeMsg') }}</small>
          </div>
          <div class="btn-wrapper text-center">
            <a href="#" class="btn btn-neutral btn-icon">
              <span class="btn-inner--icon"
                ><img src="static/img/icons/common/github.svg"
              /></span>
              <span class="btn-inner--text">Github</span>
            </a>
            <a href="#" class="btn btn-neutral btn-icon">
              <span class="btn-inner--icon"
                ><img src="static/img/icons/common/google.svg"
              /></span>
              <span class="btn-inner--text">Google</span>
            </a>
          </div>
        </div> -->
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            {{ $t('login.credentialAsk') }}
          </div>
          <form role="form" name="form" v-on:submit.prevent="handleLogin">
            <!-- Username -->
            <div class="form-group" :class="{ error: v$.user.username.$errors }">
              <base-input formClasses="input-group-alternative mb-3" v-bind:placeholder="$t('login.username')"
                addon-left-icon="ni ni-email-83" v-model="v$.user.username.$model">
              </base-input>
              <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.user.username.$errors" :key="index">
                <div class="error-msg">{{ $t(error.$message) }}</div>
              </div>
            </div>

            <!-- email -->
            <div class="form-group" :class="{ error: v$.user.email.$errors }">
              <base-input formClasses="input-group-alternative" v-bind:placeholder="$t('register.email')" type="text"
                addon-left-icon="ni ni-email-83" v-model="v$.user.email.$model">
              </base-input>
              <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.user.email.$errors" :key="index">
                <div class="error-msg"><small>{{ $t(error.$message) }}</small></div>
              </div>
            </div>

            <!-- password -->
            <div class="form-group" :class="{ error: v$.user.password.$errors }">
              <base-input formClasses="input-group-alternative mb-3" v-bind:placeholder="$t('login.password')"
                type="password" addon-left-icon="ni ni-lock-circle-open" v-model="v$.user.password.$model">
              </base-input>
              <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.user.password.$errors" :key="index">
                <div class="error-msg">{{ $t(error.$message) }}{{ error.$params.min }}</div>
              </div>
            </div>

            <div class="text-center">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="v$.user.$invalid">{{
              $t('login.signInButton') }}</base-button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import User from '../../models/user';

import useVuelidate from '@vuelidate/core'
import { required, minLength, helpers, email } from '@vuelidate/validators'

export default {
  name: "verify_account",
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      user: {
        username: {
          required: helpers.withMessage('login.errorFieldRequired', required),
        },
        email: {
          required_custom: helpers.withMessage('login.errorFieldRequired', required),
          email: helpers.withMessage('login.errorFieldEmail', email),
        },
        password: {
          required: helpers.withMessage('login.errorFieldRequired', required),
          min: helpers.withMessage('login.errorInvalidLength', minLength(6)),
        }
      },
    }
  },
  methods: {
    handleLogin() {
      if (this.user.username && this.user.password) {
        this.user.key = this.$route.query.key;
        this.$store.dispatch('auth/userVerification', this.user).then(
          () => {
            this.$store.dispatch('auth/login', this.user).then(
              () => {
                this.$router.push('/dashboard');
              },
              error => {
                console.log(error)
                if (error.response.status == 401) {
                  if (error.response.data.detail.includes("disabled")) {
                    this.error = "disabled";
                    this.message = this.$t('login.adviceActiveAccount');
                  } else if (error.response.data.detail.includes("username")) {
                    this.error = "credential"
                    this.message = this.$t('login.errorCredentials')
                  }
                }
              }
            );
          },
          error => {
            console.log(error)
            if (error.response.status == 401) {
              if (error.response.data.detail.includes("username")) {
                this.error = "credential"
                this.message = this.$t('login.errorCredentials')
              }
            }
          }
        );
      }
    },
    handleResendEmail() {

      // TBD
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/dashboard');
    }
  },
  data() {
    return {
      user: new User(null, null, null, null),
      message: "",
      error: null,

    }
  },
};
</script>
<style></style>
